import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=2ffa0576"
import script from "./projectDetail.vue?vue&type=script&lang=js"
export * from "./projectDetail.vue?vue&type=script&lang=js"
import style0 from "./projectDetail.vue?vue&type=style&index=0&id=2ffa0576&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports